const aboutEnglish = () => (
  {
    servicesTitle: 'My services',
    title: {
      part1: 'MY MISSION IS TO',
      part2: 'DESIGN & DEVELOP THE BEST WEBSITES',
      part3: 'IN THE MARKET',
    },
    description: 'I can help you build a product , feature or website Look through some \
      of my work and experience! If you like what you see and have a project you need coded, \
      don’t hesitate to contact me.',
    resume: 'Get my resume',
    skills: {
      language: 'Languages',
      framework: 'Frameworks',
      tools: 'Tools',
    },
  }
);

export default aboutEnglish;
